import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
	operatorWillBeConnectedSoon: {
		id: 'videocalls.operatorWillBeConnectedSoon',
		defaultMessage: 'Оператор скоро подключится',
	},
	cameraMuted: {
		id: 'videocalls.cameraMuted',
		defaultMessage: 'Камера выключена',
	},
	operatorMicIsMuted: {
		id: 'videocalls.operatorMicIsMuted',
		defaultMessage: 'Микрофон оператора выключен',
	},
});
